document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".shaddow_btn_custom").forEach(button => {
        button.addEventListener("click", function () {
            // Remove border
            this.style.setProperty('box-shadow', '-1px 1px 0 black', 'important');
           this.style.setProperty('transform', 'translateY(1.5px)', 'important');

            // Reset border after 1 second
            setTimeout(() => {
                this.style.removeProperty('box-shadow');
                this.style.removeProperty('transform');
            }, 300); // 1000ms = 1 second
        });
    });
});

window.updateCustomTabOffset = (function () {
  const root = document.documentElement;
  const headerStickySelector = '.header-wrapper';
  const headerTopSelector = '.universal-mega-menu-section';

  function setOffset() {
    const headerSticky = document.querySelector(headerStickySelector);
    const headerTop = document.querySelector(headerTopSelector);

    const stickyHeight = headerSticky?.offsetHeight || 0;

    let topHeight = 0;
    if (headerTop) {
      const style = getComputedStyle(headerTop);
      const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && headerTop.offsetHeight > 0;

      if (isVisible) {
        topHeight = headerTop.offsetHeight;
      }
    }

    const totalHeight = stickyHeight + topHeight - 1;
    root.style.setProperty('--cstm-tab-header-height', `${totalHeight}px`);
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        setOffset(); // recalculate on scroll based on actual visibility
        ticking = false;
      });
      ticking = true;
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    setOffset();
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", setOffset);
  });

  return setOffset;
})();

